import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, role }) => {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-[60vh] flex items-center justify-center text-stone-400">Memuat...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role) {
    const allowed = Array.isArray(role) ? role : [role];
    if (user.role !== "owner" && !allowed.includes(user.role)) return <Navigate to="/" replace />;
  }
  return children;
};
